import { createContext } from "react";

export const ServiceDeliveryModalContext = createContext();
